import VnrLink from '@components/VnrLink';
import React from 'react';

import styles from './styles.module.scss';

const BigPicturePost = (props) => {
  const { post, showModal } = props;

  const renderDate = () => {
    const publicDate = post?.public_date;
    if (!publicDate || publicDate === '') return '12.01.2021';
    const date = publicDate.split(' ')[0];
    if (!date || date === '') return '12.01.2021';

    return date.replaceAll('/', '.');
  };

  return (
    <div
      className={
        styles[post.content ? 'vnr-comp-BigPicturePost' : 'vnr-comp-BigPicturePost-no-content']
      }
    >
      <div className={styles['big-picture-post']}>
        <div>
          <span className={styles.postDetail}>{renderDate()}</span>
          {/* <VnrLink to={`/tac-gia/${post.author.acf.author_path}`}> */}
            <span className={styles.postAuthor}>{post?.author?.name ?? ''}</span>
          {/* </VnrLink> */}
        </div>

        <h3 className={styles['post-title']} onClick={showModal}>
          {post.title}
        </h3>
      </div>
    </div>
  );
};

export default BigPicturePost;
